import {combineReducers} from 'redux';
import {connectRouter} from 'connected-react-router';
import Scanner from './Scanner';
import Settings from './Settings';
import Inspections from "./Inspections";
import Merchandising from "./Merchandising";
import Reports from "./Reports";
import Inventory from "./Inventory";

export default (history) => combineReducers({
  router: connectRouter(history),
  scanner: Scanner,
  settings: Settings,
  inspections: Inspections,
  merchandising: Merchandising,
  reports: Reports,
  inventory: Inventory
});
